import { CiSearch } from "react-icons/ci"
import { Input } from "reactstrap"


const SearchBar = ({value,setValue}) => {
  return (
    <div className="d-flex align-items-center search-bar full-width gap-2 ">
    <div>
      <CiSearch color="rgba(44, 44, 44, 1)" size={24} />
    </div>
    <Input
      className="bg-transparent full-height  border-none p-0"
      style={{ borderRadius: 0 }}
      placeholder="Search"
      value={value??""}
      onChange={(e)=>setValue?.(e?.target?.value)}
    />
  </div>
  )
}

export default SearchBar
